export default "__VITE_ASSET__3548b69b__"